"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = interpret;
exports.buildSourceRule = buildSourceRule;
exports.buildOnlyRule = buildOnlyRule;
exports.buildAllRule = buildAllRule;
exports.buildUpToSubRule = buildUpToSubRule;
exports.buildLeavingSubRule = buildLeavingSubRule;
exports.buildIfSubRule = buildIfSubRule;
exports.getRuleBuilderForRule = void 0;

var _atom = require("../../utils/atom");

function interpret() {
  var rules = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

  if (!rules.length) {
    return 0;
  }

  return buildSourceRule(rules[0]);
}

var ruleBuilderDispatch = {
  mainRule: {
    only: buildOnlyRule,
    all: buildAllRule
  },
  allocationSelector: buildOnlyRule
};
var getRuleBuilderForRule = (0, _atom.makeRuleBuilder)(ruleBuilderDispatch);
exports.getRuleBuilderForRule = getRuleBuilderForRule;

function buildSourceRule(rule) {
  return (0, _atom.buildRule)(getRuleBuilderForRule, rule);
}

function buildOnlyRule(valueFinder) {
  var allocation = valueFinder("allocationSelector");
  var atLabel = valueFinder("atLabel");
  var account = valueFinder("specificAccountSelector", _atom.ALLOW_UNDEF);

  switch (atLabel) {
    case "exactly":
      {
        var amount = valueFinder("exactly");
        return function () {
          return {
            allocation: allocation,
            account: account,
            amount: amount
          };
        };
      }

    case "percentage":
      {
        var percentage = valueFinder("percentage");
        return function () {
          return {
            allocation: allocation,
            account: account,
            percentage: percentage
          };
        };
      }

    default:
      throw new Error("Cannot build source label rule w/atLabel of ".concat(atLabel));
  }
}

function buildAllRule() {
  return function (val, obj, subRules) {
    return subRules.map(function (rule) {
      return rule();
    });
  };
}

function buildUpToSubRule(valueFinder) {}

function buildLeavingSubRule(valueFinder) {}

function buildIfSubRule(valueFinder) {}